import React, { useEffect, useRef } from "react";
import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";

const ayodhyaCoords = [82.199, 26.796]; // Longitude, Latitude

const MapLibreComponent = () => {
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null); // Store the map instance

  useEffect(() => {
    if (!mapContainerRef.current) return;

    mapRef.current = new maplibregl.Map({
      container: mapContainerRef.current,
      style: "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json", // New style
      center: ayodhyaCoords,
      zoom: 12,
    });

    // Add Marker
    new maplibregl.Marker().setLngLat(ayodhyaCoords).addTo(mapRef.current);

    return () => mapRef.current?.remove(); // Cleanup on unmount
  }, []);

  return (
    <div
      ref={mapContainerRef}
      style={{ width: "100%", height: "100%", minHeight: "200px", borderRadius: "8px" }}
    />
  );
};

export default MapLibreComponent;
